import CurrencyModel from './currency.model';

const currencies = [];

currencies.push(new CurrencyModel('RUB', 'RUB', true));
currencies.push(new CurrencyModel('USD', 'USD'));
currencies.push(new CurrencyModel('EUR', 'EUR'));

export default currencies;
